import { Table } from '@quero-delivery/quero-components-web';
import { format } from '@querodelivery/qd-date-helper';
import classNames from 'classnames';
import type { Extract } from '@/_features/places/types';
import { centsToMoneyLabel } from '@/Utils/FnUtils';
import styles from './extract-row.module.scss';

function ExtractRow({ extract }: { extract: Extract }) {
  const { created_at, cents, descricao, tipo } = extract;

  return (
    <Table.Row>
      <Table.Cell>
        <span className={styles.spanTable}>
          {format(new Date(created_at), 'dd/MM/yyyy HH:mm')}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span
          className={classNames(
            cents > 0 ? styles.credit : styles.debit,
            styles.spanTable,
          )}
        >
          {centsToMoneyLabel(cents)}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span
          className={classNames(
            cents > 0 ? styles.credit : styles.debit,
            styles.spanTableCapitalized,
          )}
        >
          <p>{tipo}</p>
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className={styles.spanTableCapitalized}>
          <p>{descricao}</p>
        </span>
      </Table.Cell>
    </Table.Row>
  );
}
export { ExtractRow };
